/**
 * Fetches domain-built execution feedback from the server (E.IMPL.5 E2-01).
 *
 * @param {{
 *   providerId?: string,
 *   operationKind?: string,
 *   operationResult?: object,
 *   action?: object,
 *   success?: boolean,
 * }} params
 * @returns {Promise<string>}
 */
export async function fetchExecutionFeedback(params) {
  try {
    const res = await fetch("/api/ai/execution-feedback", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        providerId: params?.providerId || "okta",
        operationKind: params?.operationKind || params?.action?.type,
        operationResult: params?.operationResult,
        action: params?.action,
        success: params?.success,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (res.ok && typeof data?.text === "string" && data.text.trim()) {
      return data.text.trim();
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[fetchExecutionFeedback]", e);
  }

  const kind = params?.operationKind || params?.action?.type || "operation";
  const ok = params?.success !== false;
  return ok
    ? `[SYSTEM: Operation ${kind} completed]`
    : `[SYSTEM_ERROR: Operation ${kind} failed]`;
}
